import { t as e } from "../../chunks/index.es.CfT5btWg.js";
import { Node as t, Transforms as n } from "slate";
//#region lib/Image/lib/normalizeImage.ts
var r = (r, i) => {
	let [, a] = i;
	for (let [i, o] of t.children(r, a)) if (e.isBlock(i)) return n.unwrapNodes(r, {
		at: o,
		split: !0
	}), !0;
};
//#endregion
export { r as normalizeImage };
